module.exports = __webpack_public_path__ + "img/DAVID_CANNON_46-rs.be4b7b2d.jpg";